// src/services/authService.ts

import useAuth from "utils/authorization/authHandling";
import { axiosInstance } from "../../App"; // o como esté configurado tu axios
import { removeUserStoredData } from "../../utils/authorization/tokenHandling";
import { HttpRetCode } from "../../utils/webResponse/enums";
import { getFromLocalStorage, setInLocalStorage } from "../../utils/localStorage/localStorage.utils";
import { iUserPermissions } from "../../types/permissions";

export const logon = async (
  username: string,
  password: string,
): Promise<any> => {
  try {
    const response = await axiosInstance.post(
      "/logon",
      { username, password },
      { withCredentials: true },
    );

    return response;
  } catch (error: any) {
    if (
      error.response?.status === 401 ||
      error.response?.status === 302 ||
      error.response?.status === 403
    ) {
      return error.response;
    }
    throw error;
  }
};

export const refreshWebSocketToken = async (): Promise<string> => {
  const response = await axiosInstance.post<{ wstoken?: string }>("/auth/websocket-token");
  const token = response.data?.wstoken;
  if (!token) {
    throw new Error("The server did not return a WebSocket token");
  }

  const user = getFromLocalStorage<iUserPermissions>("user");
  if (!user) {
    throw new Error("Cannot update the WebSocket token because user data is unavailable");
  }

  setInLocalStorage<iUserPermissions>("user", { ...user, wstoken: token });
  window.dispatchEvent(new Event("localStorageUserUpdated"));
  return token;
};

export const logout = async (): Promise<void> => {
  try {
    const { Status } = await useAuth();
    if (Status !== HttpRetCode.UNAUTHORIZED) return;
    await axiosInstance.post("/logout", { username: "" });
  } catch (error) {
    console.error("Logout error:", error);
  } finally {
    // Always clear local data even if API call fails
    removeUserStoredData();
  }
};
